import { Injectable } from '@angular/core';
import {
  interval,
  Observable,
  startWith,
  Subject,
  switchMap,
  tap
} from 'rxjs';
import { LocalStorageConsts } from '../AppConsts';
import { HealthCheckServiceProxy } from '../services-proxies/HealthCkeckServiceProxy';
import { AppUtils } from '../utils/app-utils';

@Injectable()
export class HealthCheckService {
  heartBeat$: Observable<boolean>;

  constructor(private readonly serviceProxy: HealthCheckServiceProxy) {
    this.heartBeat$ = new Subject();
  }

  setBackendHeartbeatTimeout(heartbeatTime: number) {
    this.heartBeat$ = interval(heartbeatTime).pipe(
      startWith(0),
      switchMap(() => this.serviceProxy.checkHealth()),
      tap(this.saveStatus)
    );
  }

  loadStatus(): boolean {
    const storedStatus = localStorage.getItem(LocalStorageConsts.HealthCheckKey);
    if (AppUtils.emptyString(storedStatus)) {
      return navigator.onLine;
    } else {
      return storedStatus === 'true';
    }
  }
  saveStatus(x: boolean): void {
    localStorage.setItem(LocalStorageConsts.HealthCheckKey, x ? 'true' : 'false');
  }
}
